import axios from 'axios'
import $store from '@/store.js'
// import toTipsObj from './toTipsObj.js'

const NotManyEdit = {
  // 新增编辑
  AddEdit (param) {
    const userInfo = $store.state.common.baseUserInfo
    if (!param.logicId) {
      return
    }
    axios
      .post('/gatewayPlayoutUrl/tvu-playout/userEdit/edit', {
        ...param,
        userId: localStorage.getItem('userId'),
        email: userInfo.email,
        userName: userInfo.email
      })
      .then((res) => {
        if (res.data.errorCode == '0x0') {
        }
      }).catch(() => {})
  },
  // 关闭浏览器取消编辑
  CloseQuitEdit (param) {
    if (!param.logicId) {
      return
    }
    const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
    const data = {
      ...param,
      userId: localStorage.getItem('userId'),
      editStatus: 0
    }
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    navigator.sendBeacon(`${window.location.protocol}//${urlInfo.gatewayPlayoutUrl}/tvu-playout/userEdit/quitEdit`, formData)
  },
  // 取消编辑
  QuitEdit (param) {
    if (!param.logicId) {
      return
    }
    const data = {
      ...param,
      userId: localStorage.getItem('userId'),
      editStatus: 0
    }
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    axios
      .post('/gatewayPlayoutUrl/tvu-playout/userEdit/quitEdit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => {
        if (res.data.errorCode == '0x0') {
        }
      }).catch(() => {})
  },
  // 检查编辑
  async checkUserEdit (param) {
    let success = true
    if (!param.logicId) {
      return success
    }
    await axios
      .post('/gatewayPlayoutUrl/tvu-playout/userEdit/checkUserEdit', {
        ...param,
        userId: localStorage.getItem('userId')
      }).then((res) => {
        if (res.data.result) {
          success = true
        } else {
          window.vm.$message(res.data.errorInfo)
          success = false
        }
      }).catch(() => {
        success = true
      })
    return success
  },
  // 解锁给出提示
  ReleaseHint (ownerEmail, callback) {
    const title = ` <div>${window.vm.$t('lang.releaseUserFront')} <span style="color:#33ab4f">${ownerEmail}</span> ${window.vm.$t('lang.releaseUserLater')}<br/>${window.vm.$t('lang.releaseUserNextLine')}</div>`
    window.vm.$alert(title, {
      dangerouslyUseHTMLString: true,
      confirmButtonText: window.vm.$t('lang.GotIt')
    }).then(() => {
      callback()
    }).catch(() => {
      callback()
    })
  }
}
export default NotManyEdit
